import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './Bank.module.scss';

import BankOptions from './BankOptions.js'
import DestinationOption from '../../components/DestinationOption/DestinationOption';
import HelpBox from '../../components/HelpBox/HelpBox';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ProgressButtons from '../../components/Progress/ProgressButtons/ProgressButtons';
import ProgressBar from '../../components/Progress/ProgressBar/ProgressBar';
import {
  BANK_STEP,
  DISTRIBUTION_METHOD_STEP,
  TOLL_FREE_NUMBER, DESTINATION_STEP
} from '../../settings/settings';
import RMLConnection from '../../components/RMLConnection/RMLConnection';
import { getExistingBanks } from '../../redux/modules/existingBanks/existingBanks.selectors';
import { getSelectedBank } from '../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  bankStatusList,
} from '../../settings/settings';
import {getAssociatedAgreementsBuyBank} from "../../redux/modules/associatedAgreements/associatedAgreements.selectors";


const Bank = (props) => {
  const userBanks = useSelector(getExistingBanks);
  const [selectedBank, setSelectedBank] = useState(useSelector(getSelectedBank));

  if (userBanks.length === 1 && !selectedBank.bankAgreementID) {
    setSelectedBank(userBanks[0]);
  }
  const retirementFunds = useSelector(getAssociatedAgreementsBuyBank);
  const isDisabled = (option) => {
    return bankStatusList.includes(option.bankStatus) || retirementFunds[option.bankAgreementID].length === 0;
  };

  return (
    <div className="rmd-distribution-wrapper">
      <div className="sticky-header">
        <div className="heading">Auto-RMD Setup</div>
        <ProgressButtons
          edit={props.edit}
          currentStep={BANK_STEP}
          payload={selectedBank}
          previousStep={DESTINATION_STEP}
          nextStep={DISTRIBUTION_METHOD_STEP}
          {...props}
          disabled={!selectedBank.bankAgreementID}
        >
          <ProgressBar />
        </ProgressButtons>
      </div>
        <PageWrapper step={BANK_STEP} isHelpCol={true}>
            <div className="scroll-wrapper">
              <div className="reinvest-title">
                Where do you want to deposit your <span className="orphan-line"> RMD? </span>
              </div>
              <div className={styles['option-container']}>
                {userBanks.map((option, key) => {
                  const disabled = isDisabled(option);
                  return (
                    <DestinationOption
                      disabled={disabled}
                      addressLock={true}
                      blockContainer={true}
                      selectOption={() => setSelectedBank(option)}
                      isSelected={
                        option.bankAgreementID === selectedBank.bankAgreementID
                      }
                      selectable={true}
                      optionText={BankOptions({option, disabled})}
                      key={key}
                    />
                  );
                })}
                <HelpBox step={BANK_STEP} />
                <RMLConnection phoneNumber={TOLL_FREE_NUMBER} />
              </div>
            </div>
        </PageWrapper>
    </div>
  );
};

export default Bank;
